import { AuthTypes } from 'client/_redux/types/authTypes';
import { IAnonymousUser } from 'server/models/AnonymousUser/types';
import { IUser } from 'server/models/User';
import { IToken } from 'types/Auth';
import { IReduxAction } from 'types/IReduxAction';

export interface IAuthState {
  isLoggedIn: boolean;
  loading: boolean;
  loaded: boolean;
  error: boolean;

  user?: IUser | IAnonymousUser;

  token?: IToken;
}

const initialState: IAuthState = {
  isLoggedIn: false,
  loading: false,
  loaded: false,
  error: false,
};

export default (state = initialState, { type, payload }: IReduxAction): IAuthState => {
  switch (type) {
    case AuthTypes.USER_LOGGED_OUT_TOKEN:
      return initialState;
    case AuthTypes.SET_TOKEN:
    case AuthTypes.SIGNIN_SUCCESS:
      return { ...state, isLoggedIn: true, loaded: true, token: payload };
    case AuthTypes.SIGNIN_ANONYMOUS:
      return { ...state, isLoggedIn: false, loaded: true, token: payload };

    case AuthTypes.RESET_TOKEN:
      return { ...state, isLoggedIn: false, loaded: true };
    default:
      return state;
  }
};
